export enum MESSAGE_TYPE {
  PRAYER = 'prayer',
  TEXT = 'text_message',
  PRAYER_ON_COMMENT = 'prayer_on_comment',
  THANKS_INTENTION_PRAYER = 'thanks_intention_prayer',
  THANKS_ARRIVAL_INTENTION_PRAYER = 'thanks_arrival_intention_prayer',
  THANKS_BIRTHDAY_INTENTION_PRAYER = 'thanks_birthday_intention_prayer',
  GODSON_JOINED = 'godson_joined',
  REPLY_TO_UPLIFT_MESSAGE = 'reply_to_uplift_message',
}
